import { render, staticRenderFns } from "./VesselMarker.vue?vue&type=template&id=10850398&scoped=true"
import script from "./VesselMarker.vue?vue&type=script&lang=js"
export * from "./VesselMarker.vue?vue&type=script&lang=js"
import style0 from "./VesselMarker.vue?vue&type=style&index=0&id=10850398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10850398",
  null
  
)

export default component.exports